// extracted by mini-css-extract-plugin
export default {"options":"kTZMZS","option":"RoUZxc"};